import React from "react";

const Footer = () => {
  return (
    <>
      <footer>
        <p>Radom, 2022 - {new Date().getFullYear()}.</p>
      </footer>
    </>
  );
};

export default Footer;
